import React from 'react';
import FormLayout from 'Components/layouts/common/FormLayout';
import { ForgotpasswordForm } from 'Components/authentication/ForgotPasswordForm';

export function Forgotpassword() {
  return (
    <FormLayout>
      <ForgotpasswordForm />
    </FormLayout>
  );
}
